import App from '@/models/App'

export default class TrafficShipScheduleEvent extends App {
    static get entity() {
        return 'TrafficShipScheduleEvents'
    }

    static all() {
        return this.query().orderBy('createdAt', 'desc').get()
    }

    static findById(id) {
        return this.query().whereId(id).withAllRecursive().first()
    }

    static fields() {
        return {
            id: this.attr(''),
            trafficShipScheduleId: this.attr(''),
            status: this.attr(''),
            name: this.attr(''),
            from: this.attr(''),
            to: this.attr(''),
            comment: this.attr(''),
        }
    }

    static apiConfig = {
        actions: {
            create(params) {
                return this.post(
                    `/traffic/ship/schedule/events`,
                    App.post(params),
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        baseURL: App.apiURL(),
                    }
                )
            },
            update(trafficShipScheduleEventId, params) {
                return this.patch(
                    `traffic/ship/schedule/events/${trafficShipScheduleEventId}`,
                    App.patch(params),
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        baseURL: App.apiURL(),
                    }
                )
            },
            destroy(trafficShipScheduleEventId) {
                return this.delete(
                    `traffic/ship/schedule/events/${trafficShipScheduleEventId}`,
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        delete: trafficShipScheduleEventId,
                        baseURL: App.apiURL(),
                    }
                )
            },
        },
    }
}
